<!--
 * @Author: 1739017283@qq.com
 * @Date: 2025-04-07 15:07:10
 * @LastEditors: 1739017283@qq.com
 * @LastEditTime: 2025-05-28 16:44:47
 * @FilePath: \knowledge-graph\src\views\Home\home.vue
 * @Description: 首页
-->
<template>
  <div class="page-home">
    <div class="page-home-block-one">
      <h2>{{ $i18n.$t('历代高僧传知识图谱') }}</h2>
      <div class="page-home-block-one-search">
        <!-- <input type="text" :placeholder="$i18n.$t('请输入想要了解的人物')" v-model="searchKey" @keyup.enter="searchAction"> -->
        <search-index v-model="searchKey" :placeholder="$i18n.$t('请输入想要了解的人物')"></search-index>
        <div class="page-home-block-one-search-btn" @click.stop="searchAction">
          <img src="@/assets/home/home-search.png" alt="">
        </div>
      </div>
    </div>
    <div class="page-home-block-two">
      <div class="page-home-block-two-main">
        <div class="page-home-title">
          <img src="@/assets/home/home-title-left.png" alt="">
          <span>{{ $i18n.$t('人物展示') }}</span>
          <img src="@/assets/home/home-title-right.png" alt="">
        </div>
        <div class="page-home-block-two-nav">
          <img src="@/assets/home/home-left.png" alt="" @click.stop="scrollLeft">
          <div class="page-home-block-two-nav-list" ref="navList">
            <div class="page-home-block-two-nav-list-row" @click.stop="idChange(row)" :class="{ active: row.Id === params.Id }" v-for="(row, index) in blockTwoNavList" :key="index">{{ row.Name }}</div>
          </div>
          <img src="@/assets/home/home-right.png" alt="" @click.stop="scrollRight">
        </div>
        <div class="page-home-block-two-content">
          <div class="page-home-block-two-content-main" v-loading="relationLoading">
            <chinaMap :list="perRelationData" :personName="perRelationDataKey" :show-detail="false" v-if="params.type === '人物足迹'" />
            <vis-index :data="relationData" :show-detail="false" v-else />
          </div>
          <div class="page-home-block-two-content-type">
            <div class="page-home-block-two-content-type-item" :class="{active: $i18n.$t(params.type) === $i18n.$t('社会关系')}" @click.stop="typeChange('社会关系')">{{ $i18n.$t('社会关系') }}</div>
            <div class="page-home-block-two-content-type-item" :class="{active: $i18n.$t(params.type) === $i18n.$t('师承关系')}" @click.stop="typeChange('师承关系')">{{ $i18n.$t('师承关系') }}</div>
            <div class="page-home-block-two-content-type-item" :class="{active: $i18n.$t(params.type) === $i18n.$t('人物足迹')}" @click.stop="typeChange('人物足迹')">{{ $i18n.$t('人物足迹') }}</div>
            <div class="page-home-block-two-content-type-item" :class="{active: $i18n.$t(params.type) === $i18n.$t('传记记载')}" @click.stop="typeChange('传记记载')">{{ $i18n.$t('传记记载') }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="page-home-block-three">
      <div class="page-home-block-three-main">
        <div class="page-home-title">
          <img src="@/assets/home/home-title-left.png" alt="">
          <span>{{ $i18n.$t('人地关系') }}</span>
          <img src="@/assets/home/home-title-right.png" alt="">
        </div>
        <div class="page-home-block-two-nav">
          <img src="@/assets/home/home-left.png" alt="" @click.stop="placeScrollLeft">
          <div class="page-home-block-two-nav-list" ref="placeNavList">
            <div class="page-home-block-two-nav-list-row" @click.stop="nameChange(row)" :class="{ active: row === placeParams.Name }" v-for="(row, index) in blockThreeNavList" :key="index">{{ row }}</div>
          </div>
          <img src="@/assets/home/home-right.png" alt="" @click.stop="placeScrollRight">
        </div>
        <div class="page-home-block-three-content" v-loading="placeLoading">
          <div class="map-container" id="screenMap" v-show="placeType === 'map'"></div>
          <vis-index :data="placeRelationData" :show-detail="false" v-show="placeType === 'vis'" />
        </div>
      </div>
    </div>
    <div class="page-home-block-four">
      <div class="page-home-block-four-main">
        <div class="page-home-title">
          <img src="@/assets/home/home-title-left.png" alt="">
          <span>{{ $i18n.$t('传记阅读') }}</span>
          <img src="@/assets/home/home-title-right.png" alt="">
        </div>
        <div class="page-home-block-four-content">
          <div class="page-home-block-four-content-row" v-for="bio in biographieList" :key="bio.id">
            <h3>{{ bio.Name }}</h3>
            <div class="page-home-block-four-content-row-bottom">
              <p>{{ $i18n.$t('正传人物数：') }}{{ bio.relation_count }}</p>
              <p>{{ $i18n.$t('附见人物数：') }}{{ bio.other_count }}</p>
              <div class="page-home-block-four-content-row-bottom-btn" @click.stop="toReadAdd(bio)">{{  [$i18n.$t('补续高僧传'), $i18n.$t('名僧传抄')].includes(bio.Name) ? $i18n.$t('建设中...') :  $i18n.$t('在线研读') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page-home-footer">
      <div class="page-home-footer-main">
        <div class="page-home-footer-main-context">
          <p>
            <a target="_blank" href="https://www.rushi-ai.com/article/download">{{ $i18n.$t('下载专区') }}</a>
            <a target="_blank" href="https://guji.rushi-ai.net/">{{ $i18n.$t('如是古籍工具平台') }}</a>
            <a target="_blank" href="https://dict.rushi-ai.net/">{{ $i18n.$t('如是古籍字典') }}</a>
            <a target="_blank" href="/about">{{ $i18n.$t('关于我们') }}</a>
          </p>
          <p>{{ $i18n.$t('©2019-2025 杭州灵隐寺、北京如是人工智能技术研究院版权所有·浙ICP备12015887号-12') }}</p>
          <p>{{ $i18n.$t('互联网宗教信息服务许可证：浙（2022）0000070') }}</p>
          <p>
            <a target="_blank" href="https://www.rushi-ai.com/terms">{{ $i18n.$t('用户协议') }}</a>
            <a target="_blank" href="https://www.rushi-ai.com/privacy">{{ $i18n.$t('隐私政策') }}</a>
          </p>
        </div>
        <div class="page-home-footer-main-qr">
          <img src="@/assets/home/rs_scan-IkIjE8Yw.jpg" alt="">
          <p>{{ $i18n.$t('关注公众号') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { hotPerson, homeRelation, hotAddress, personAddressRelation } from '@/api/home'
import { allBiographie, personRecordedIn } from '@/api/biographie'
import { allPlace, addressRelation } from '@/api/place'
import { i18n } from '@/i18n'
export default {
  name: 'HomeIndex',
  meta: {
    title: i18n.$t('首页')
  },
  data () {
    const searchKey = sessionStorage.getItem('homeSearch')
    return {
      TMap: window.TMap,
      blockTwoNavList: [],
      blockThreeNavList: [],
      biographieList: [],
      relationData: null,
      relationLoading: false,
      params: {
        Id: '',
        type: '社会关系'
      },
      perRelationDataKey: '',
      perRelationData: [],
      placeType: 'map',
      placeParams: {
        Name: ''
      },
      placeLoading: false,
      placeRelationData: {
        searchKey: ''
      },
      map: null,
      zoom: 3,
      placeList: [],
      timeout: null,
      multiCircle: null,
      multiLabel: null,
      searchKey: searchKey || ''
    }
  },
  created () {
    this.getHotPerson()
    this.getHomeAddress()
    this.getAllBiographie()
  },
  mounted () {
    this.initMap()
  },
  methods: {
    toReadAdd (row) {
      if ([i18n.$t('补续高僧传'), i18n.$t('名僧传抄')].includes(row.Name)) return false
      window.open(row.Url, '_blank')
    },
    getHomeAddress () {
      hotAddress().then(res => {
        this.blockThreeNavList = res.data.map(e => e.Name)
      })
    },
    searchAction () {
      sessionStorage.setItem('homeSearch', this.searchKey)
      this.$router.push({
        path: '/advanceSearch?searchKey=' + this.searchKey
      })
    },
    getAllPlace () {
      allPlace().then(res => {
        this.placeList = res.data
        this.setMark()
      })
    },
    setMark () {
      const scale = 3 / this.zoom
      let rate = 1000
      if (this.zoom > 3) rate = 800
      if (this.zoom > 5) rate = 600
      if (this.zoom > 8) rate = 400
      if (this.zoom > 12) rate = 200
      if (this.zoom > 17) rate = 100
      if (this.zoom > 24) rate = 50
      this.multiCircle = new this.TMap.MultiCircle({
        map: this.map,
        zIndex: 9999,
        styles: {
          default: new this.TMap.CircleStyle({
            color: 'rgba(152,116,67,1)', // 半透明底色
            showBorder: true,
            borderColor: '#987443',
            borderWidth: 2
          })
        },
        geometries: this.placeList.map(e => ({
          position: new this.TMap.LatLng(e.Latitude, e.Longitude), // 上海
          value: e.relation_count
        })).map(marker => ({
          center: marker.position,
          radius: marker.value * rate * scale, // 单位：米
          styleId: 'default'
        }))
      })
      if (this.zoom > 5) {
        this.multiLabel = new this.TMap.MultiLabel({
          map: this.map,
          zIndex: 9999,
          styles: {
            'count-style': new this.TMap.LabelStyle({
              color: '#ffffff',
              fontSize: 10 / scale,
              // backgroundColor: '#987443',
              // borderRadius: '50%',
              // width: 28,
              // height: 28,
              lineHeight: '28px',
              textAlign: 'center'
              // border: '2px solid #fff',
              // boxShadow: '0 2px 8px rgba(0,0,0,0.15)' // 与现有阴影一致
            })
          },
          geometries: this.placeList.map(e => ({
            position: new this.TMap.LatLng(e.Latitude, e.Longitude), // 上海
            value: e.relation_count
          })).map(marker => ({
            position: marker.position,
            styleId: 'count-style',
            content: marker.value.toString()
          }))
        })
      }
    },
    initMap () {
      const center = new this.TMap.LatLng(39.916527, 116.397128)
      this.map = new this.TMap.Map('screenMap', { // 地图初始化配置
        pitch: 0,
        rotation: 0,
        zoom: 3,
        // maxZoom: 8,
        minZoom: 3,
        showControl: false,
        center: center
      })
      // this.map.setBaseMap({ type: 'satellite' })
      this.map.on('zoom_changed', e => {
        this.zoom = e.zoom
        if (this.timeout) {
          clearTimeout(this.timeout)
        }
        this.timeout = setTimeout(async () => {
          if (this.multiCircle) {
            await this.multiCircle.setMap(null)
          }
          if (this.multiLabel) {
            await this.multiLabel.destroy()
          }
          this.setMark()
        }, 500)
      })
      this.getAllPlace()
    },
    placeScrollLeft () {
      const list = this.$refs.placeNavList
      list.scrollBy({
        left: -206, // 每次滚动200px（根据实际项目调整）
        behavior: 'smooth' // 平滑滚动
      })
    },
    placeScrollRight () {
      const list = this.$refs.placeNavList
      list.scrollBy({
        left: 206, // 每次滚动200px
        behavior: 'smooth'
      })
    },
    nameChange (row) {
      if (this.placeParams.Name === row) {
        this.placeParams.Name = ''
        this.placeType = 'map'
      } else {
        this.placeParams.Name = row
        this.placeType = 'vis'
        // 获取图数据
        this.getAddressRelation(this.placeParams.Name)
      }
    },
    getAddressRelation (Name) {
      this.placeLoading = true
      addressRelation({
        Name
      }).then(res => {
        if (res.data.address && res.data.address.length > 0) {
          // this.showMap = false
          // this.$refs.chinaMap.close()
          this.placeRelationData = {
            searchKey: Name,
            data: [
              ...res.data.data,
              ...res.data.address
            ],
            link: res.data.link
          }
        } else {
          this.placeRelationData = {
            data: [],
            link: []
          }
        }
      }).finally(() => {
        this.placeLoading = false
      })
    },
    scrollLeft () {
      const list = this.$refs.navList
      list.scrollBy({
        left: -206, // 每次滚动200px（根据实际项目调整）
        behavior: 'smooth' // 平滑滚动
      })
    },
    scrollRight () {
      const list = this.$refs.navList
      list.scrollBy({
        left: 206, // 每次滚动200px
        behavior: 'smooth'
      })
    },
    idChange (row) {
      this.params.Id = row.Id
      this.getPersonRelation()
    },
    typeChange (type) {
      this.params.type = type
      this.getPersonRelation()
    },
    getHotPerson () {
      hotPerson().then(res => {
        this.blockTwoNavList = res.data
        if (this.blockTwoNavList[0]) {
          this.params.Id = this.blockTwoNavList[0].Id
          this.getPersonRelation()
        }
      })
    },
    getAllBiographie () {
      allBiographie().then(res => {
        this.biographieList = res.data
      })
    },
    getPersonRelation () {
      this.relationLoading = true
      if (this.params.type === '人物足迹') {
        const row = this.blockTwoNavList.find(e => e.Id === this.params.Id)
        if (row) {
          this.perRelationDataKey = row.Name
          personAddressRelation({
            type: '人物足迹',
            Name: row.Name
          }).then(res => {
            this.perRelationData = res.data.data.map(e => {
              return {
                ...e,
                markers: res.data.link.find(l => l.target === e.Id)
              }
            })
          }).finally(() => {
            this.relationLoading = false
          })
        } else {
          this.perRelationData = []
          this.perRelationDataKey = ''
          this.relationLoading = false
        }
      } else if (this.params.type === '传记记载') {
        personRecordedIn(this.params).then(res => {
          this.relationData = {
            data: [
              ...res.data.data,
              ...res.data.person
            ],
            link: res.data.link
          }
        }).finally(() => {
          this.relationLoading = false
        })
      } else {
        homeRelation(this.params).then(res => {
          this.relationData = {
            data: [
              ...res.data.data,
              ...res.data.person
            ],
            link: res.data.link
          }
        }).finally(() => {
          this.relationLoading = false
        })
      }
    }
  }
}
</script>
